import { customization } from '@yola/ws-sdk';
import editorActionTypes from '../../editor/constants/action-types';
import actionTypes from '../constants/action-types';
import constants from '../constants';
import getCompiledFontPairConfig from '../helpers/compile-font-pair-config';

const getFontLoaderScript = (usedFonts) => `
  WebFontConfig = {
    google: {
      families: ['${usedFonts}'],
    },
    classes: !1,
    events: !1,
  };
  (function(doc) {
    var element = doc.createElement('script'),
    head = doc.head;
    element.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
    element.async = !0
    head.appendChild(element, head);
    })(document);
`;

const userFontsLoader = () => (next) => (action) => {
  next(action);

  if (
    action.type === actionTypes.CHANGE_FONT_PAIRS ||
    action.type === editorActionTypes.SHOW_EDITOR
  ) {
    const existingScript = document.getElementById(constants.USER_FONTS_SCRIPT_TAG_ID);

    if (existingScript) {
      existingScript.remove();
    }

    const fontPairs = customization.accessors.getCurrentFontPair();

    if (!fontPairs) return;

    let compiledConfig = fontPairs;

    if (fontPairs.isCustom) {
      compiledConfig = getCompiledFontPairConfig(fontPairs);
    }

    const {
      variables: { usedFonts },
    } = compiledConfig;
    const scriptFunction = getFontLoaderScript(usedFonts.replaceAll(' | ', ', '));
    const scriptElem = document.createElement('script');

    scriptElem.id = constants.USER_FONTS_SCRIPT_TAG_ID;
    scriptElem.innerHTML = scriptFunction;

    document.body.appendChild(scriptElem);
  }
};

export default userFontsLoader;
